import styles from "./Dot.module.css";
import type { DotKind } from "./dot-kind.ts";

export function Dot({ kind, label }: { readonly kind: DotKind; readonly label?: string }) {
  const a11y = label === undefined ? { "aria-hidden": true } : { role: "img", "aria-label": label };
  return (
    <svg className={styles.dot} viewBox="0 0 10 10" width="10" height="10" focusable="false" {...a11y}>
      {kind === "sombra" ? <circle className={styles.ring} cx="5" cy="5" r="3.9" pathLength="12" /> : <circle className={styles[kind]} cx="5" cy="5" r="4" />}
    </svg>
  );
}
